/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交（任务单 DEV-120352）；视觉基准 docs/旅游落地页/cj商旅-01.html。
 * 注意事项：
 * 1. /cj-business-travel 为从零新建的纯展示型 React SSR 落地页（CJ 商旅），按原型 1:1 还原 8 大区块；
 *    DEV-126262 在区块 4 之后追加第 9 块 CityVideos（中国城市竖版视频，源码由提出方另行提供）。
 * 2. 导出方式与 entity/odm 一致：Component.fetch = fetchData 后 withSSR 包裹；
 *    不引入 Header/Footer（由框架 Layout 注入），头部与页面背景的融合在 index.less 内处理（需求5）。
 * 3. 文案统一取自 constants.getConstants() 的 i18next 取词（pageId=cjBusinessTravel）。
 */
import React, { useMemo } from 'react';
import withSSR from '../../hoc/withSSR';
import fetchData from './fetch';
import './index.less';
import { getConstants } from './constants';

import Hero from './components/Hero';
import About from './components/About';
import Trip from './components/Trip';
import Experiences from './components/Experiences';
import CityVideos from './components/CityVideos';
import Services from './components/Services';
import Payment from './components/Payment';
import CityExplorer from './components/CityExplorer';
import Cta from './components/Cta';

function CjBusinessTravelPage(props) {
  // 第2次补充：图片已迁至公共资源仓（static-resource-platform/resources/egg/cjBusinessTravel），
  // 按 cdnHost 拼 CDN 路径（同 /odm、/alternatives）；本地开发 cdnHost 为空串，退化为同源路径。
  var pageData = (props && props.pageData) || {};
  var cdnHost = pageData.cdnHost || '';
  var constants = useMemo(function () { return getConstants(cdnHost); }, [cdnHost]);

  return (
    <div className="cj-business-travel-page" data-gtag-module="cjBusinessTravel">
      <Hero data={constants.HERO} />
      <About data={constants.ABOUT} />
      <Trip data={constants.TRIP} />
      <Experiences data={constants.EXPERIENCES} />
      {/* DEV-126262：中国城市竖版视频模块，位置由开发拍板 —— 紧跟 featured-china-experiences 之后 */}
      <CityVideos data={constants.CITY_VIDEOS} />
      <Services data={constants.SERVICES} />
      <Payment data={constants.PAYMENT} />
      <CityExplorer data={constants.CITIES} />
      <Cta data={constants.CTA} />
    </div>
  );
}

CjBusinessTravelPage.fetch = fetchData;

export default withSSR(CjBusinessTravelPage);
